/** Icons of the Squadre screens (Squadre v7): views, «Al seguito», trackers, hand placement and
 *  the row menu. Same set as the rest (outline, grid 24, stroke 1.7); `Icon` merges every file. */
export const TEAM_PATHS = {
  more: (
    <>
      <circle cx="5.6" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="18.4" cy="12" r="1.5" fill="currentColor" stroke="none" />
    </>
  ),
  rows: <path d="M3.4 6h17.2M3.4 12h17.2M3.4 18h17.2" />,
  cards: (
    <>
      <rect x="3.4" y="4" width="7.4" height="7" />
      <rect x="13.2" y="4" width="7.4" height="7" />
      <rect x="3.4" y="13" width="7.4" height="7" />
      <rect x="13.2" y="13" width="7.4" height="7" />
    </>
  ),
  columns: (
    <>
      <rect x="3.4" y="3.4" width="7.4" height="17.2" />
      <rect x="13.2" y="3.4" width="7.4" height="17.2" />
    </>
  ),
  dog: (
    <path d="M6 10.4 4 8.2M7 12.6h8.6l2-3.4 2.4.6v-2.6L17 5.6l-1.4 2H7.4A3.4 3.4 0 0 0 4 11v1.6M7 12.6v6.6M15.6 12.6v6.6M11 12.6v6.6" />
  ),
  horse: (
    <>
      <path d="M8.4 21v-5.2L5 13.4a1.8 1.8 0 0 1 .1-2.9l4.6-3.6.9-3.5 2.3 2.3c3.8.5 6.1 3.4 6.1 7.6V21" />
      <path d="M12.6 9.8c-.6 1.6-.4 3.4.8 5" />
      <circle cx="9.8" cy="8.8" r=".9" fill="currentColor" stroke="none" />
    </>
  ),
  gear: (
    <>
      <rect x="3.4" y="8.4" width="17.2" height="11.2" rx="1.4" />
      <path d="M8.6 8.4V5.8a1.2 1.2 0 0 1 1.2-1.2h4.4a1.2 1.2 0 0 1 1.2 1.2v2.6M3.4 13h17.2M10.6 13v2h2.8v-2" />
    </>
  ),
  lora: (
    <>
      <path d="M12 21V11" />
      <circle cx="12" cy="9" r="2" />
      <path d="M8.2 5.6a5.4 5.4 0 0 0 0 6.8M15.8 5.6a5.4 5.4 0 0 1 0 6.8M5.4 3.2a9 9 0 0 0 0 11.6M18.6 3.2a9 9 0 0 1 0 11.6" />
    </>
  ),
  hand: (
    <path d="M8 13V5.6a1.6 1.6 0 0 1 3.2 0V12M11.2 11V4.4a1.6 1.6 0 0 1 3.2 0V12M14.4 11.4V6.2a1.6 1.6 0 0 1 3.2 0V15a6 6 0 0 1-6 6h-.6a6 6 0 0 1-5-2.7L3.4 15a1.6 1.6 0 0 1 2.6-1.8L8 15.6" />
  ),
  expand: <path d="M4 9V4h5M20 9V4h-5M4 15v5h5M20 15v5h-5" />,
} as const;
